// ConfirmDeleteModal.js
import React from 'react';
import './ConfirmDeleteModal.css'; 

const ConfirmDeleteModal = ({ show, onClose, onConfirm, phase }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <p>Are you sure you want to delete this phase?</p>
        {phase && (
          <div>
            <p><strong>Phase Name:</strong> {phase.name}</p>
          </div>
        )}
        <div className="modal-buttons">
          <button className="modal-button confirm-button" onClick={onConfirm}>Yes</button>
          <button className="modal-button cancel-button" onClick={onClose}>No</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
